import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Layout } from '@/components/Layout';
import Login from '@/pages/Login';
import Forbidden from '@/pages/Forbidden';
import NotFound from '@/pages/NotFound';
import Dashboard from '@/pages/Dashboard';
import CompaniesList from '@/pages/companies/CompaniesList';
import CompanyCreate from '@/pages/companies/CompanyCreate';
import CompanyDetail from '@/pages/companies/CompanyDetail';
import SubscriptionsList from '@/pages/subscriptions/SubscriptionsList';
import PlansList from '@/pages/plans/PlansList';
import PlanForm from '@/pages/plans/PlanForm';
import PricingCatalogPage from '@/pages/pricing/PricingCatalog';
import AllUsers from '@/pages/users/AllUsers';
import AiProvidersPage from '@/pages/ai-providers/AiProvidersPage';
import AiModelsPage from '@/pages/ai-providers/AiModelsPage';
import AiUsagePage from '@/pages/ai-providers/AiUsagePage';
import AiRequestsPage from '@/pages/ai-providers/AiRequestsPage';
import AiCreditsPage from '@/pages/ai-providers/AiCreditsPage';
import WhatsappHealthPage from '@/pages/health/WhatsappHealthPage';
import SystemHealthPage from '@/pages/health/SystemHealthPage';
import AuditLogPage from '@/pages/audit-log/AuditLogPage';
import AccountSettings from '@/pages/settings/AccountSettings';
import IntegrationsSettings from '@/pages/settings/IntegrationsSettings';
import DefaultTemplatesList from '@/pages/default-templates/DefaultTemplatesList';
import IndustryConfigs from '@/pages/industry-configs/IndustryConfigs';
import IndustryConfigDetail from '@/pages/industry-configs/IndustryConfigDetail';
import DefaultTemplateForm from '@/pages/default-templates/DefaultTemplateForm';
import BlueprintsList from '@/pages/blueprints/BlueprintsList';
import BlueprintEditor from '@/pages/blueprints/BlueprintEditor';
import ExchangeRates from '@/pages/fx/ExchangeRates';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/403" element={<Forbidden />} />
      <Route element={<ProtectedRoute role="super_admin"><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/companies" element={<CompaniesList />} />
        <Route path="/companies/new" element={<CompanyCreate />} />
        <Route path="/companies/:uid" element={<CompanyDetail />} />
        <Route path="/subscriptions" element={<SubscriptionsList />} />
        <Route path="/plans" element={<PlansList />} />
        <Route path="/plans/new" element={<PlanForm />} />
        <Route path="/plans/:id" element={<PlanForm />} />
        <Route path="/pricing" element={<PricingCatalogPage />} />
        <Route path="/users" element={<AllUsers />} />
        <Route path="/ai-providers" element={<Navigate to="/ai/providers" replace />} />
        <Route path="/ai/providers" element={<AiProvidersPage />} />
        <Route path="/ai/models" element={<AiModelsPage />} />
        <Route path="/ai/usage" element={<AiUsagePage />} />
        <Route path="/ai/requests" element={<AiRequestsPage />} />
        <Route path="/ai/credits" element={<AiCreditsPage />} />
        <Route path="/whatsapp-health" element={<WhatsappHealthPage />} />
        <Route path="/system-health" element={<SystemHealthPage />} />
        <Route path="/audit-log" element={<AuditLogPage />} />
        <Route path="/settings" element={<AccountSettings />} />
        <Route path="/integrations" element={<IntegrationsSettings />} />
        <Route path="/default-templates" element={<DefaultTemplatesList />} />
        <Route path="/industry-configs" element={<IndustryConfigs />} />
        <Route path="/industry-configs/:industryKey" element={<IndustryConfigDetail />} />
        <Route path="/blueprints" element={<BlueprintsList />} />
        <Route path="/blueprints/:familyKey" element={<BlueprintEditor />} />
        <Route path="/exchange-rates" element={<ExchangeRates />} />
        <Route path="/default-templates/new" element={<DefaultTemplateForm />} />
        <Route path="/default-templates/:uid" element={<DefaultTemplateForm />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
